import React , { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import { Link, Outlet } from "react-router-dom";
import { logout,setToken,setRegion  } from "../redux/authSlice";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { api } from "../api";
import { getRegionList} from "../helpers/listsApi";


const Layout = () => {

    const user = useSelector((state) => state.auth.user);
    const region = useSelector((state) => state.auth.region);
    const switchRegion = useSelector((state) => state.auth.switchRegion);
    const token = useSelector((state) => state.auth.token);
    const { userType: role } = useSelector((state) => state.auth.user);
    const [regions, setRegions] = useState([]);
    const [isRegionLoad, setIsRegionLoad] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();



    const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
    };

    

  const handleRegionChange = async (e) => {
  if(switchRegion){
  const newRegion = e.target.value;
   setIsRegionLoad(true); 
  try {
    const response = await api.resellerType.changeRegion({region_id:newRegion}, token);
    if (response && response.token) {
      dispatch(setToken(response.token));
       const regioninfo = {
            id: newRegion,
            name: response.reseller_regionname,
            currency: response.currency
        };
        dispatch(setRegion(regioninfo));
   
    }
  } finally {
    setIsRegionLoad(false);
  }
  }


  };

    useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch region list
        const regionList = await getRegionList(null, token);
        setRegions(regionList);


      } catch (error) {
        console.error("Error fetching region data:", error);
      }
    };

    if(role === 1 || role === 2){
    fetchData();
    }
    
    
  }, [token, dispatch,region,role]);



  return (
    <div id="wrapper">
    <Sidebar /> {/* Include Sidebar component */}

    <div id="content-wrapper">
      <nav className="navbar navbar-expand static-top">
        <button className="btn btn-link btn-sm text-white" id="sidebarToggle">
          <i className="fa fa-bars"></i>
        </button>
        <ul className="navbar-nav nav-right-ul ml-auto">
              <li className="nav-item d-flex align-items-center mr-3">
              {(role === 1 || role === 2) && (
              <select
                className="form-control"
                value={region.id}
                onChange={handleRegionChange}
                style={{   minWidth: "100px",
                height: "35px",
                padding: "5px 15px",
                lineHeight: "18px",
                appearance: "auto", // ensures default arrow shows in most browsers
                WebkitAppearance: "auto",
                MozAppearance: "auto",}}
                disabled={switchRegion ? false : true}
              >
       
                    {regions.map(regionlist => (
                      <option key={regionlist.value} value={regionlist.value}>
                        {regionlist.label}
                      </option>
                    ))}
              </select>
              )}

            </li>
 
          <li className="nav-item dropdown no-arrow">
            <button
              className="nav-link dropdown-toggle"
              id="userDropdown"
             
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span className="user-name mr-2"> {user?.userName}</span>
              <i className="bx bx-chevron-down"></i>
            </button>
            <div className="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown">
              <button className="dropdown-item">
                 <Link className="nav-link" to="/Profile"  style={{ padding: 0 }}><i className="bx bx-user"></i> Profile</Link>
              </button>
              <div className="dropdown-divider"></div>
              <button className="dropdown-item" onClick={handleLogout}>
                <i className="bx bx-power-off"></i> Logout
              </button>
            </div>
          </li>
        </ul>
      </nav>

      <Outlet /> {/* This will load the specific page content */}
    {isRegionLoad && (
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          pointerEvents: 'none', // Allow clicks through
          zIndex: 999,
        }}
      >
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
       )}

    </div>
  </div>
  );
};

export default Layout;
